var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderTreeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 100,
    viewBox: "0 0 125 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5430",
    "data-name": "Rectangle 5430",
    width: 125,
    height: 100,
    fill: "#f5f5f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868",
    transform: "translate(0 -0.235)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867",
    transform: "translate(0 0.235)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28632",
    "data-name": "Path 28632",
    d: "M58.639,119.875c3.985,0,7.969-.007,11.954,0,2.913.006,4.6,1.686,4.614,4.59q.016,3.772,0,7.546a4.184,4.184,0,0,1-4.555,4.518q-12.085.015-24.168,0a4.194,4.194,0,0,1-4.549-4.525q-.019-3.838,0-7.676a4.187,4.187,0,0,1,4.489-4.452c4.072-.014,8.143,0,12.214,0",
    transform: "translate(-27.366 -78.291)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28633",
    "data-name": "Path 28633",
    d: "M148.487,0c3.985,0,7.969-.007,11.954,0,2.913.006,4.6,1.686,4.614,4.59q.017,3.772,0,7.546a4.184,4.184,0,0,1-4.555,4.518q-12.085.015-24.169,0a4.194,4.194,0,0,1-4.549-4.525q-.018-3.838,0-7.676A4.186,4.186,0,0,1,136.272.007c4.071-.014,8.142,0,12.214,0",
    transform: "translate(-86.014 -0.089)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28634",
    "data-name": "Path 28634",
    d: "M238.312,136.532c-4.028,0-8.056.008-12.084,0-2.913-.007-4.6-1.691-4.608-4.6q-.015-3.773,0-7.546a4.183,4.183,0,0,1,4.431-4.509q12.214-.02,24.429,0a4.163,4.163,0,0,1,4.41,4.4c.022,2.645.027,5.291,0,7.936a4.143,4.143,0,0,1-4.361,4.314c-4.071.023-8.143.006-12.214.006",
    transform: "translate(-144.656 -78.289)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28635",
    "data-name": "Path 28635",
    d: "M16.6,256.343c-3.985,0-7.969.007-11.954,0-2.973-.007-4.631-1.692-4.639-4.7-.006-2.515-.016-5.031,0-7.546a4.167,4.167,0,0,1,4.4-4.408q12.214-.022,24.428,0a4.172,4.172,0,0,1,4.442,4.5q.023,3.838,0,7.676a4.17,4.17,0,0,1-4.465,4.476c-4.072.017-8.143,0-12.214,0",
    transform: "translate(0 -156.452)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28636",
    "data-name": "Path 28636",
    d: "M148.469,239.684c3.985,0,7.969-.007,11.954,0,2.916.006,4.6,1.684,4.617,4.586.011,2.558.02,5.117,0,7.676a4.152,4.152,0,0,1-4.418,4.389q-12.215.023-24.429,0a4.163,4.163,0,0,1-4.42-4.389q-.031-3.967,0-7.936a4.158,4.158,0,0,1,4.353-4.323c4.115-.022,8.23-.006,12.344-.006",
    transform: "translate(-86.002 -156.452)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28637",
    "data-name": "Path 28637",
    d: "M280.187,256.345c-4.028,0-8.056.009-12.084,0a4.193,4.193,0,0,1-4.56-4.513q-.02-3.838,0-7.676a4.182,4.182,0,0,1,4.478-4.463q12.149-.017,24.3,0a4.18,4.18,0,0,1,4.493,4.446q.028,3.9,0,7.806a4.154,4.154,0,0,1-4.411,4.4c-4.072.02-8.143.006-12.214.006",
    transform: "translate(-172.02 -156.454)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28638",
    "data-name": "Path 28638",
    d: "M91.889,196.518H87.7v-8.109H46.1V196.5H41.97c0-2.938-.116-5.838.039-8.723.11-2.037,1.911-3.475,4.148-3.549,2.164-.072,4.332-.023,6.5-.027h1.712v-4.209h4.175v4.106h62.387v-4.1h4.13v4.09c1.59,0,3.044,0,4.5,0,1.343,0,2.688-.037,4.029.016a4.04,4.04,0,0,1,3.971,3.748c.109,2.852.027,5.711.027,8.648h-4.106v-8.152H91.889Z",
    transform: "translate(-27.369 -117.511)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28639",
    "data-name": "Path 28639",
    d: "M148.577,76.637h-4.145V70.573h-62.4V76.6H77.9c0-2.231-.121-4.437.035-6.624.149-2.083,1.955-3.518,4.264-3.572,2.64-.062,5.283-.039,7.924-.045q9.809-.023,19.618-.04h1.375V60.052h4.15v6.254h1.6q13.447-.017,26.894-.031c3.2,0,4.813,1.6,4.821,4.77,0,1.817,0,3.634,0,5.592",
    transform: "translate(-50.817 -39.266)",
    fill: "#f5f5f5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTreeIcon);
export default __webpack_public_path__ + "static/media/FolderTreeIcon.9029d413c26c30573e7cbf8053709dda.svg";
export { ForwardRef as ReactComponent };